import addToCart from './AddToCart'

import {combineReducers} from 'redux';

const allReducer = combineReducers({
    addToCart
})

export default allReducer; 